var render = function () {
  var _vm$item, _vm$item2, _vm$item3, _vm$item4, _vm$item5, _vm$item6, _vm$item6$cas_organiz, _vm$item7, _vm$item8, _vm$item9, _vm$item10, _vm$item11, _vm$item12, _vm$item13, _vm$item14, _vm$item14$sync_vendo, _vm$item15, _vm$item15$sync_vendo, _vm$item16, _vm$item16$sync_vendo, _vm$item17, _vm$item17$sync_vendo, _vm$item18, _vm$item19, _vm$item20, _vm$item21, _vm$vendorReportForma;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Publisher',
        to: '/vendor'
      }, {
        label: (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.name
      }],
      "title": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.name
    }
  }), _c('div', {
    staticClass: "w-full p-4 my-3 bg-white rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h4', {
    staticClass: "text-xl font-bold text-gray-900"
  }, [_vm._v("Publisher Details")]), _c('Button', {
    on: {
      "click": function ($event) {
        return _vm.$router.push(("/vendor/edit/" + (_vm.$route.params.id)));
      }
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('EditFilled', {
          attrs: {
            "color": "white",
            "className": "w-4 h-4"
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" Edit ")])], 1), _c('div', {
    staticClass: "flex mt-2"
  }, [_c('div', {
    staticClass: "flex-col w-1/2"
  }, [_c('DescriptionList', [_c('DescriptionTerm', [_vm._v("Publisher Image")]), _c('DescriptionDetail', {
    attrs: {
      "withSlotLoading": "",
      "isLoading": _vm.isLoadingVendor,
      "className": "mt-2"
    },
    scopedSlots: _vm._u([{
      key: "slotLoading",
      fn: function () {
        return [_c('Skeleton', {
          staticStyle: {
            "height": "144px",
            "width": "144px"
          },
          attrs: {
            "className": "rounded-md"
          }
        })];
      },
      proxy: true
    }])
  }, [!!((_vm$item3 = _vm.item) !== null && _vm$item3 !== void 0 && _vm$item3.icon_image_normal) ? _c('img', {
    staticClass: "form-control-file",
    staticStyle: {
      "border": "1px solid #ccc"
    },
    attrs: {
      "alt": "Vendor Image",
      "height": "144",
      "width": "144",
      "src": _vm.imageSrc
    },
    on: {
      "error": function ($event) {
        return _vm.handleImageError($event);
      }
    }
  }) : _c('img', {
    staticClass: "form-control-file",
    staticStyle: {
      "border": "1px solid #ccc"
    },
    attrs: {
      "height": "144",
      "width": "144",
      "src": _vm.imagePath,
      "alt": "Vendor Image"
    }
  })]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Publisher Name")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.name) || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Slug")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.slug) || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Organization Name")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(((_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : (_vm$item6$cas_organiz = _vm$item6.cas_organization) === null || _vm$item6$cas_organiz === void 0 ? void 0 : _vm$item6$cas_organiz.name) || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Description")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_c('div', {
    ref: "descriptionText",
    class: ['gd-line-clamp', {
      'gd-line-clamp-expanded': _vm.isDescriptionExpanded
    }]
  }, [_vm._v(" " + _vm._s(((_vm$item7 = _vm.item) === null || _vm$item7 === void 0 ? void 0 : _vm$item7.description) || '-') + " ")]), _vm.showDescriptionToggle ? _c('div', {
    staticClass: "flex items-center mt-1 cursor-pointer"
  }, [_c('button', {
    staticClass: "ml-auto mr-1 text-xs font-semibold text-gray-900",
    on: {
      "click": _vm.toggleDescriptionExpanded
    }
  }, [_vm._v("Read " + _vm._s(_vm.isDescriptionExpanded ? 'Less' : 'More'))]), _vm.isDescriptionExpanded ? _c('ChevronUpFilled', {
    attrs: {
      "className": "w-3 h-3 text-gray-900"
    }
  }) : _c('ChevronDownFilled', {
    attrs: {
      "className": "w-3 h-3 text-gray-900"
    }
  })], 1) : _vm._e()]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Publisher Type")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s((_vm$item8 = _vm.item) !== null && _vm$item8 !== void 0 && _vm$item8.is_external ? 'External' : 'Internal'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Vendor Source")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(((_vm$item9 = _vm.item) === null || _vm$item9 === void 0 ? void 0 : _vm$item9.vendor_source) || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Vendor Content")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(_vm.vendorContent || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Display Content")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(((_vm$item10 = _vm.item) === null || _vm$item10 === void 0 ? void 0 : _vm$item10.display_content) || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Meta")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(((_vm$item11 = _vm.item) === null || _vm$item11 === void 0 ? void 0 : _vm$item11.meta) || '-'))])], 1)], 1), _c('div', {
    staticClass: "flex-col w-1/2"
  }, [_c('DescriptionList', [_c('DescriptionTerm', [_vm._v("Created Date")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(_vm._f("formatDateCompact")((_vm$item12 = _vm.item) === null || _vm$item12 === void 0 ? void 0 : _vm$item12.created)))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Last Modified")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(_vm._s(_vm._f("formatDateCompact")((_vm$item13 = _vm.item) === null || _vm$item13 === void 0 ? void 0 : _vm$item13.modified)))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("New Premium Vendor Content ID")]), ((_vm$item14 = _vm.item) === null || _vm$item14 === void 0 ? void 0 : (_vm$item14$sync_vendo = _vm$item14.sync_vendor) === null || _vm$item14$sync_vendo === void 0 ? void 0 : _vm$item14$sync_vendo.vendor_premium_id_ax) !== '-1' ? _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [((_vm$item15 = _vm.item) === null || _vm$item15 === void 0 ? void 0 : (_vm$item15$sync_vendo = _vm$item15.sync_vendor) === null || _vm$item15$sync_vendo === void 0 ? void 0 : _vm$item15$sync_vendo.vendor_premium_id_ax) === '0' ? _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm",
      "className": "text-gray-900",
      "loading": _vm.requestBtnLoading
    },
    on: {
      "click": function ($event) {
        return _vm.requestPremiumId();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.requestBtnLoading ? 'Loading...' : 'Request ID') + " ")]) : ((_vm$item16 = _vm.item) === null || _vm$item16 === void 0 ? void 0 : (_vm$item16$sync_vendo = _vm$item16.sync_vendor) === null || _vm$item16$sync_vendo === void 0 ? void 0 : _vm$item16$sync_vendo.vendor_premium_id_ax) === '1' ? _c('Label', {
    attrs: {
      "variant": "yellow"
    }
  }, [_vm._v(" In Process ")]) : _c('span', [_vm._v(_vm._s((_vm$item17 = _vm.item) === null || _vm$item17 === void 0 ? void 0 : (_vm$item17$sync_vendo = _vm$item17.sync_vendor) === null || _vm$item17$sync_vendo === void 0 ? void 0 : _vm$item17$sync_vendo.vendor_premium_id_ax))])], 1) : _vm._e(), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Approval Status")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_c('Label', {
    attrs: {
      "variant": _vm.vendorStatus.labelVariant
    }
  }, [_vm._v(_vm._s(_vm.vendorStatus.text))])], 1), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Status")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_c('Label', {
    attrs: {
      "variant": (_vm$item18 = _vm.item) !== null && _vm$item18 !== void 0 && _vm$item18.is_active ? 'green' : 'gray'
    }
  }, [_vm._v(" " + _vm._s((_vm$item19 = _vm.item) !== null && _vm$item19 !== void 0 && _vm$item19.is_active ? 'Active' : 'Inactive') + " ")])], 1)], 1)], 1)])]), _c('div', {
    staticClass: "w-full p-4 my-3 bg-white rounded-lg shadow-sm"
  }, [_c('h4', {
    staticClass: "text-xl font-bold text-gray-900"
  }, [_vm._v("Publisher Agreement")]), _c('div', {
    staticClass: "flex mt-2"
  }, [_c('div', {
    staticClass: "flex-col w-1/2"
  }, [_c('DescriptionList', [_c('DescriptionTerm', [_vm._v("Publisher ID AX")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendor
    }
  }, [_vm._v(" " + _vm._s((_vm$item20 = _vm.item) !== null && _vm$item20 !== void 0 && _vm$item20.sync_vendor ? (_vm$item21 = _vm.item) === null || _vm$item21 === void 0 ? void 0 : _vm$item21.sync_vendor.vendor_id_ax : '-') + " ")]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Formula ID")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingItemRevenue
    }
  }, [_vm._v(" " + _vm._s(_vm.itemRevenue ? _vm.itemRevenue.formula_id : '-') + " ")]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Formula Name")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingItemRevenue
    }
  }, [_vm._v(" " + _vm._s(_vm.itemRevenue ? _vm.itemRevenue.formula_name : '-') + " ")]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Payment Currency")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingItemRevenue
    }
  }, [_vm._v(" " + _vm._s(_vm.paymentCurrencyText) + " ")]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Default Fixed Amount")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingItemRevenue
    }
  }, [_vm._v(" " + _vm._s(_vm.itemRevenue ? _vm.itemRevenue.default_fixed_amount : '-') + " ")]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Default Percentage Amount")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingItemRevenue
    }
  }, [_vm._v(" " + _vm._s(_vm.itemRevenue ? ((_vm.toPercent(_vm.itemRevenue.default_percentage_amount)) + " %") : '-') + " ")])], 1)], 1), _c('div', {
    staticClass: "flex-col w-1/2"
  }, [_c('DescriptionList', [_c('DescriptionTerm', [_vm._v("Status")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingItemRevenue
    }
  }, [!_vm.itemRevenue ? [_vm._v("-")] : [_c('Label', {
    attrs: {
      "variant": _vm.itemRevenue.is_active ? 'green' : 'gray'
    }
  }, [_vm._v(" " + _vm._s(_vm.itemRevenue.is_active ? 'Active' : 'Inactive') + " ")])]], 2)], 1)], 1)])]), _c('div', {
    staticClass: "w-full p-4 my-3 bg-white rounded-lg shadow-sm"
  }, [_c('h4', {
    staticClass: "text-xl font-bold text-gray-900"
  }, [_vm._v("Vendor Report Format")]), _c('div', {
    staticClass: "flex mt-2"
  }, [_c('div', {
    staticClass: "flex-col w-1/2"
  }, [_c('DescriptionList', [_c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Content Type")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendorReportFormat
    }
  }, [_vm._v(_vm._s(_vm.vendorReportFormatContentType || '-'))]), _c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Reason")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendorReportFormat
    }
  }, [_c('div', {
    ref: "reasonText",
    class: ['gd-line-clamp', {
      'gd-line-clamp-expanded': _vm.isReasonExpanded
    }]
  }, [_vm._v(" " + _vm._s(((_vm$vendorReportForma = _vm.vendorReportFormat) === null || _vm$vendorReportForma === void 0 ? void 0 : _vm$vendorReportForma.status) || '-') + " ")]), _vm.showReasonToggle ? _c('div', {
    staticClass: "flex items-center mt-1 cursor-pointer"
  }, [_c('button', {
    staticClass: "ml-auto mr-1 text-xs font-semibold text-gray-900",
    on: {
      "click": _vm.toggleReasonExpanded
    }
  }, [_vm._v("Read " + _vm._s(_vm.isReasonExpanded ? 'Less' : 'More'))]), _vm.isReasonExpanded ? _c('ChevronUpFilled', {
    attrs: {
      "className": "w-3 h-3 text-gray-900"
    }
  }) : _c('ChevronDownFilled', {
    attrs: {
      "className": "w-3 h-3 text-gray-900"
    }
  })], 1) : _vm._e()])], 1)], 1), _c('div', {
    staticClass: "flex-col w-1/2"
  }, [_c('DescriptionList', [_c('DescriptionTerm', {
    attrs: {
      "className": "gd-dt"
    }
  }, [_vm._v("Status")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingVendorReportFormat
    }
  }, [_c('Label', {
    attrs: {
      "variant": _vm.vendorReportFormat.is_active ? 'green' : 'gray'
    }
  }, [_vm._v(" " + _vm._s(_vm.vendorReportFormat.is_active ? 'Active' : 'Inactive') + " ")])], 1)], 1)], 1)])]), _c('div', {
    staticClass: "w-full p-4 my-3 bg-white rounded-lg shadow-sm"
  }, [_c('h4', {
    staticClass: "text-xl font-bold text-gray-900"
  }, [_vm._v("Aggregation")]), _c('div', {
    staticClass: "flex"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.aggregateTableHeaders,
      "data": _vm.content,
      "rowKey": _vm.aggregateTableRowKeys,
      "isLoading": _vm.isLoadingContent,
      "withAction": false,
      "withPagination": false,
      "className": "w-full"
    },
    scopedSlots: _vm._u([{
      key: "countHeader",
      fn: function () {
        return [_vm._v(" Quantity ")];
      },
      proxy: true
    }, {
      key: "count",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('div', [_vm._v(" " + _vm._s(value) + " ")])];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }